import React, {useEffect} from 'react'
import {Route, Routes, useNavigate} from 'react-router-dom'
import {PageTitle, useLayout} from '../../../_metronic/layout/core'
import EnterTransactions from './EnterTransactions'
import ViewTransactions from './ViewTransactions'
import AgingReport from './Aging Report'
import {TrialBalanceIndex} from './TrialBalance'

const Transactions: React.FC = () => {
  const {company, financialYear} = useLayout()
  const navigate = useNavigate()
  useEffect(() => {
    if (!company || !company.value || !financialYear || !financialYear.value) {
      navigate('/companies')
    }
  }, [company.value, financialYear.value])

  return (
    <Routes>
      <Route
        path='enter/*'
        element={
          <>
            <PageTitle>Enter Transactions</PageTitle>
            <EnterTransactions />
          </>
        }
      />
      <Route
        path='view/*'
        element={
          <>
            <PageTitle>View Transactions</PageTitle>
            <ViewTransactions />
          </>
        }
      />
      <Route
        path='trial-balance/*'
        element={
          <>
            <PageTitle>Trial Balance</PageTitle>
            <TrialBalanceIndex />
          </>
        }
      />
      <Route
        path='aging-report/*'
        element={
          <>
            <PageTitle>Aging Report</PageTitle>
            <AgingReport />
          </>
        }
      />
    </Routes>
  )
}

export default Transactions
